import React, { useEffect, useState } from 'react';
import { AiFillDelete, AiFillFileAdd, AiFillPrinter } from 'react-icons/ai';
import { BiExport, BiImport } from 'react-icons/bi';
import { IoDuplicateOutline } from 'react-icons/io5';
import TableManager from '../../../components/tableManager/TableManager';
import { convertStringToNumber } from '../../Utils';
import NotiDialog from '../../components/NotiDialog';

const defaultValues = {
	ma_hoa_don: '',
	ky_hieu_hoa_don: '',
	so_hd: '',
	so_seri: '',
	t_tien: 0,
	t_tien_nt: 0,
	thue_suat: 0,
	t_thue: 0,
	t_thue_nt: 0,
	t_hd: 0,
	t_hd_nt: 0,
	ma_kh: '',
	ma_kh_cn: '',
	ten_kh_cn: '',
	ten_kh: '',
	dia_chi: '',
	ma_so_thue: '',
	ten_vt: '',
	line: 0,
	ngay_hd: '',
	tk_thue_co: '',
	ma_thue: '',
	tk_du_thue: '',
};

function TabVatRa({ data, readonly, handleGetDataVatRa, view, isFieldNt, isTotalVoucher }) {
	const columns = [
		{
			Header: 'K.hiệu số h.đơn',
			accessor: 'ky_hieu_hoa_don',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
			type: 'text',
		},
		{
			Header: 'Số hoá đơn',
			accessor: 'so_hd',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			type: 'text',
		},
		{
			Header: 'Ngày hoá đơn',
			accessor: 'ngay_hd',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
			type: 'date',
			handleOnChange: (index, value) => {
				updateMyData(index, 'ngay_hd', value.toISOString());
			},
		},
		{
			Header: 'TK thuế',
			accessor: 'tk_thue_co',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'tk_thue_co', item.tk);
				},
				valueField: 'tk',
				labelField: 'ten_tk',
				api: 'account',
				q: {
					status: true,
					loai_tk: 1,
				},
				prefix: true,
				getLabel: (item) => {
					return `${item.tk} - ${item.ten_tk}`;
				},
			},
		},
		{
			Header: 'TK đối ứng',
			accessor: 'tk_du_thue',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'tk_du_thue', item.tk);
				},
				valueField: 'tk',
				labelField: 'ten_tk',
				api: 'account',
				q: {
					status: true,
					loai_tk: 1,
				},
				prefix: true,
				getLabel: (item) => {
					return `${item.tk} - ${item.ten_tk}`;
				},
			},
		},
		{
			Header: `Tiền hàng ${isFieldNt?.ma_nt}`,
			accessor: 't_tien_nt',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'number',
			Filter: false,
			handleOnChange: (index, value) => {
				updateMyData(index, 't_tien', convertStringToNumber(value) * isFieldNt.ty_gia);
				updateMyData(
					index,
					't_thue_nt',
					convertStringToNumber(value) * isDataVoucherVatRa[index].thue_suat * 0.01
				);
				updateMyData(
					index,
					't_thue',
					convertStringToNumber(value) * isDataVoucherVatRa[index].thue_suat * isFieldNt.ty_gia * 0.01
				);
			},
		},
		{
			Header: 'Tiền hàng VND',
			accessor: 't_tien',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'number',
			Filter: false,
		},
		{
			Header: 'Thuế suất',
			accessor: 'thue_suat',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ma_thue', item.ma_thue);
					updateMyData(index, 'thue_suat', item.thue_suat);
					updateMyData(index, 'tk_thue_co', item.tk_thue_co);
					updateMyData(index, 't_thue_nt', item.thue_suat * isDataVoucherVatRa[index].t_tien_nt * 0.01);
					updateMyData(index, 't_thue', item.thue_suat * isDataVoucherVatRa[index].t_tien * 0.01);
				},
				valueField: 'ma_thue',
				labelField: 'ten_thue',
				api: 'vat',
				q: { status: true },
				getLabel: (item) => {
					return `${item.ten_thue}`;
				},
			},
		},
		{
			Header: `Tiền thuế ${isFieldNt?.ma_nt}`,
			accessor: 't_thue_nt',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'number',
			Filter: false,
			handleOnChange: (index, value) => {
				updateMyData(index, 't_thue', convertStringToNumber(value) * isFieldNt.ty_gia);
			},
		},
		{
			Header: `Tiền thuế VND`,
			accessor: 't_thue',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'number',
			Filter: false,
		},
		{
			Header: 'Mã khách',
			accessor: 'ma_kh',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ma_kh', item.ma_kh);
					updateMyData(index, 'ten_kh', item.ten_kh);
					updateMyData(index, 'dia_chi', item.dia_chi);
					updateMyData(index, 'ma_so_thue', item.ma_so_thue);
				},
				valueField: 'ma_kh',
				labelField: 'ten_kh',
				api: 'customer',
				q: {
					status: true,
				},
				prefix: true,
				getLabel: (item) => {
					return `${item.ma_kh} - ${item.ten_kh}`;
				},
			},
		},
		{
			Header: 'Khách hàng',
			accessor: 'ten_kh',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
		},
		{
			Header: 'Địa chỉ',
			accessor: 'dia_chi',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'text',
		},
		{
			Header: 'Mã số thuế',
			accessor: 'ma_so_thue',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
			type: 'text',
		},
		{
			Header: 'S.phẩm, dịch vụ',
			accessor: 'ten_vt',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'text',
		},
		{
			Header: 'Diễn giải',
			accessor: 'dien_giai',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
			type: 'text',
		},
		{
			Header: 'Mã hoá đơn',
			accessor: 'ma_hoa_don',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'text',
		},
	];

	const [isDataVoucherVatRa, setIsDataVoucherVatRa] = useState([]);
	const [dataSelected, setDataSelected] = useState([]);

	const [openDelete, setOpenDelete] = useState(false);

	useEffect(() => {
		if (data === undefined || data?.vatras.length < 1) {
			const newData = [];
			for (let i = 0; i < 1; i++) {
				newData.push({
					...defaultValues,
					line: i + 1,
					t_tien: isTotalVoucher?.t_tien,
					t_tien_nt: isTotalVoucher?.t_tien / isFieldNt?.ty_gia,
				});
			}
			setIsDataVoucherVatRa(newData);
		} else {
			setIsDataVoucherVatRa(data?.vatras);
		}
	}, []);

	useEffect(() => {
		for (let i = 0; i < isDataVoucherVatRa.length; i++) {
			if (isDataVoucherVatRa[i]?.so_hd === '') {
				updateMyData(i, 't_tien', isTotalVoucher?.t_tien);
				updateMyData(i, 't_tien_nt', isTotalVoucher?.t_tien / isFieldNt?.ty_gia);
			}
		}
	}, [isTotalVoucher?.t_tien]);

	const skipResetRef = React.useRef(false);
	const updateMyData = (rowIndex, columnId, value) => {
		skipResetRef.current = true;
		setIsDataVoucherVatRa((old) =>
			old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...row,
						[columnId]: value,
					};
				}
				return row;
			})
		);
	};
	useEffect(() => {
		skipResetRef.current = false;
		handleGetDataVatRa && handleGetDataVatRa(isDataVoucherVatRa);
	}, [isDataVoucherVatRa]);

	useEffect(() => {
		console.log('vatra');
		for (let i = 0; i < isDataVoucherVatRa.length; i++) {
			updateMyData(i, 't_tien', convertStringToNumber(isDataVoucherVatRa[i].t_tien_nt) * isFieldNt?.ty_gia);
			updateMyData(i, 't_thue', convertStringToNumber(isDataVoucherVatRa[i].t_thue_nt) * isFieldNt?.ty_gia);
		}
	}, [isFieldNt]);

	const menuTabDetail = [
		{
			id: 1,
			tabName: 'Thêm',
			icon: <AiFillFileAdd />,
			handle: () => {
				handleOpenAddDetailItemVoucher();
			},
		},
		// {
		// 	id: 2,
		// 	tabName: "Chuyển lên",
		// 	icon: <AiOutlineArrowUp />,
		// 	handle: () => {
		// 		// handleMoveRowItemVoucher('up');
		// 	},
		// },
		// {
		// 	id: 3,
		// 	tabName: "Chuyển xuống",
		// 	icon: <AiOutlineArrowDown />,
		// 	handle: () => {
		// 		// handleMoveRowItemVoucher('down');
		// 	},
		// },
		{
			id: 4,
			tabName: 'Nhân dòng',
			icon: <IoDuplicateOutline />,
			handle: () => {
				handleDuplicateRowItemVoucher();
			},
		},
		{
			id: 5,
			tabName: 'Xoá',
			icon: <AiFillDelete />,
			handle: () => {
				handleDeleteItemVoucher();
			},
		},
		// {
		// 	id: 6,
		// 	tabName: "Lấy dữ liệu",
		// 	icon: <AiFillCopy />,
		// 	handle: () => {
		// 		console.log(isDataVoucherVatRa);
		// 	},
		// },
		{
			id: 7,
			tabName: 'Nhập',
			icon: <BiImport />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		{
			id: 8,
			tabName: 'Xuất',
			icon: <BiExport />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		{
			id: 9,
			tabName: 'In',
			icon: <AiFillPrinter />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
	];

	const handleOpenAddDetailItemVoucher = () => {
		skipResetRef.current = true;
		setIsDataVoucherVatRa((old) => [
			...old,
			{
				...defaultValues,
				line: old.length,
				t_tien: isTotalVoucher?.t_tien,
				t_tien_nt: isTotalVoucher?.t_tien / isFieldNt?.ty_gia,
			},
		]);
	};

	//On select row
	const onSelectRowClick = (data) => {
		setDataSelected(data);
	};
	const handleDeleteItemVoucher = async () => {
		if (dataSelected.length <= 0) {
			setOpenDelete(true);
		} else {
			if (isDataVoucherVatRa && dataSelected) {
				const newData = isDataVoucherVatRa.filter((item) => {
					const index = dataSelected.findIndex((selectedItem) => selectedItem.line === item.line);
					return index === -1;
				});

				newData.forEach((item, index) => {
					item.line = index;
				});

				setIsDataVoucherVatRa(newData);
				setDataSelected([]);
			}
		}
	};
	const handleCloseDelete = () => {
		setOpenDelete(false);
	};

	const handleMoveRowItemVoucher = async (type) => {
		if (data?.details && dataSelected) {
			// Kiểm tra đang ở vị trí nào trong mảng
			const index = dataSelected[0].line;

			if (type === 'up' && index !== 0) {
				// đổi chỗ với phần tử trước
				const temp = data?.details[index - 1];
				data.details[index - 1] = data?.details[index];
				data.details[index] = temp;
			} else if (type === 'down' && index !== data?.details?.length - 1) {
				// đổi chỗ với phần tử sau
				const temp = data?.details[index + 1];
				data.details[index + 1] = data?.details[index];
				data.details[index] = temp;
			}

			// Cập nhật lại line
			data.details.forEach((item, index) => {
				item.line = index;
			});

			try {
				// await context.apis.asyncPostList(context.userInfo.token, "pt1", {
				// 	...data,
				// });
				// await getDataVoucherPT();
				console.log('dataMove', data);
				setDataSelected([]);
			} catch (error) {
				console.log(error);
			}
		}
	};

	//Nhân dòng
	const handleDuplicateRowItemVoucher = async () => {
		skipResetRef.current = true;
		dataSelected.forEach((item) => {
			delete item._id;
		});
		//  vòng lặp để tạo ra các dòng mới
		const newData = dataSelected.map((item) => {
			return { ...item, line: isDataVoucherVatRa.length };
		});

		setIsDataVoucherVatRa((old) => [...old, ...newData]);
	};

	return (
		<div className="box_tab_detail_vouvher">
			<div className="box_tab_detail_vouvher__content">
				<TableManager
					idTable={view ? 'table-vatra-voucher-view' : 'table-vatra-voucher'}
					columns={columns}
					data={view ? data?.vatras : isDataVoucherVatRa || []}
					updateMyData={updateMyData}
					skipReset={skipResetRef.current}
					selectRow={view ? false : true}
					onSelectRowClick={onSelectRowClick}
					readonly={readonly}
					TbodyMaxHeight={'11vh'}
					handleOpenAddDetailItemVoucher={handleOpenAddDetailItemVoucher}
					pagination={false}
					hiddenColumns={isFieldNt?.ma_nt === 'VND' ? ['t_tien', 't_thue', 't_hd'] : []}
					toolBar={
						<>
							{view ? (
								''
							) : (
								<div className="box_tab_detail_vouvher__header">
									{menuTabDetail.map((item) => {
										const shouldDisplayItem =
											dataSelected.length > 0 || (item.id !== 4 && item.id !== 5);
										if (shouldDisplayItem) {
											return (
												<div key={item.id} onClick={item.handle} title={`${item.tabName}`}>
													{item.icon} <span className="tabname_tool_bar">{item.tabName}</span>
												</div>
											);
										}
										return null;
									})}
								</div>
							)}
						</>
					}
				/>
				<NotiDialog
					open={openDelete}
					handleClose={handleCloseDelete}
					title="Thông báo"
					content="Vui lòng chọn ít nhất 1 dòng để thực hiện chức năng này"
				/>
			</div>
		</div>
	);
}

export default TabVatRa;
